import { useCoreStore } from '@/shared/store'
import { useGoogleAnalytics } from '@/shared/composables/useGoogleAnalytics/useGoogleAnalytics'

export const getAbTest = async (code: string) => {
  const coreStore = useCoreStore()
  const gaService = useGoogleAnalytics()

  const value = await coreStore.getAbTest(code)
  if (value) {
    gaService.sendABTest(code, value)
  }
}